import { render, staticRenderFns } from "./WBtnPrint.vue?vue&type=template&id=01097c44&scoped=true&"
import script from "./WBtnPrint.vue?vue&type=script&lang=js&"
export * from "./WBtnPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01097c44",
  null
  
)

export default component.exports